import React, { useState, useEffect } from 'react';
import { CheckCircle, Error, Close } from '@mui/icons-material';

const Notification = ({ type = 'success', message, onClose, autoClose = true, duration = 5000 }) => {
  const [isVisible, setIsVisible] = useState(true);
  
  useEffect(() => {
    if (autoClose && isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, isVisible, onClose]);
  
  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };
  
  if (!isVisible) return null;
  
  return (
    <div className={`fixed top-4 right-4 z-50 max-w-md w-full shadow-lg rounded-lg overflow-hidden transition-all duration-300 transform ${
      isVisible ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0'
    } ${
      type === 'success' ? 'bg-green-50 border-l-4 border-green-500' :
      type === 'error' ? 'bg-red-50 border-l-4 border-red-500' :
      type === 'warning' ? 'bg-yellow-50 border-l-4 border-yellow-500' :
      'bg-blue-50 border-l-4 border-blue-500'
    }`}>
      <div className="p-4 flex items-start">
        <div className={`flex-shrink-0 mr-3 ${
          type === 'success' ? 'text-green-500' :
          type === 'error' ? 'text-red-500' :
          type === 'warning' ? 'text-yellow-500' :
          'text-blue-500'
        }`}>
          {type === 'success' ? (
            <CheckCircle className="w-6 h-6" />
          ) : (
            <Error className="w-6 h-6" />
          )}
        </div>
        <div className="flex-1">
          <p className={`text-sm font-medium ${
            type === 'success' ? 'text-green-800' :
            type === 'error' ? 'text-red-800' :
            type === 'warning' ? 'text-yellow-800' :
            'text-blue-800'
          }`}>
            {message}
          </p>
        </div>
        <button
          onClick={handleClose}
          className={`ml-4 flex-shrink-0 ${
            type === 'success' ? 'text-green-500 hover:text-green-700' :
            type === 'error' ? 'text-red-500 hover:text-red-700' :
            type === 'warning' ? 'text-yellow-500 hover:text-yellow-700' :
            'text-blue-500 hover:text-blue-700'
          }`}
        >
          <Close className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default Notification;
